import Button from 'components/UI/Button';
import Link from 'components/UI/Link';
import Switch from 'components/UI/Switch';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './CookieConsent.scss';
function setCookie(cName, cValue, expDays) {
    let date = new Date();
    date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + date.toUTCString();
    document.cookie = cName + '=' + cValue + '; ' + expires + '; path=/';
}
function acceptAll() {
    setCookie('_cookieConsent', 'all', 90);
    gtag('consent', 'update', {
        ad_storage: 'granted',
        analytics_storage: 'granted',
    });
}
function acceptSome(ads, analytics) {
    if (ads && analytics) {
        acceptAll();
    }
    if (ads && !analytics) {
        setCookie('_cookieConsent', 'ad', 90);
        gtag('consent', 'update', {
            ad_storage: 'granted',
            analytics_storage: 'denied',
        });
    }
    if (!ads && analytics) {
        setCookie('_cookieConsent', 'analytics', 90);
        gtag('consent', 'update', {
            ad_storage: 'denied',
            analytics_storage: 'granted',
        });
    }
    if (!ads && !analytics) {
        rejectAll();
    }
}
function rejectAll() {
    setCookie('_cookieConsent', 'none', 90);
    gtag('consent', 'update', {
        ad_storage: 'denied',
        analytics_storage: 'denied',
    });
}
function getCookie(cName) {
    const name = cName + '=';
    const cDecoded = decodeURIComponent(document.cookie);
    const cArr = cDecoded.split('; ');
    let res;
    cArr.forEach((val) => {
        if (val.indexOf(name) === 0)
            res = val.substring(name.length);
    });
    return res;
}
function CookieConsent() {
    const cookiesIsSet = !!getCookie('_cookieConsent');
    const [showCookieConsent, setShowCookieConsent] = useState(true);
    const [showCustomizeCookies, setShowCustomizeCookies] = useState(false);
    const { t } = useTranslation();
    const [adConsent, setAdConsent] = useState(false);
    const [analyticsConsent, setAnalyticsConsent] = useState(false);
    const [hideCookieConsent, setHideCookieConsent] = useState(cookiesIsSet);
    if (hideCookieConsent) {
        return null;
    }
    if (showCookieConsent) {
        return (React.createElement("div", { className: "cookie-consent__container" },
            React.createElement("div", { className: "cookie-consent__description" },
                React.createElement("h3", { className: "cookie-consent__description--header" }, t('cookieConsentTitle')),
                t('cookieConsentDescription')),
            React.createElement("div", { className: "cookie-consent__description" },
                React.createElement("h3", { className: "cookie-consent__description--header" }, t('cookieConsentMarketingTitle')),
                t('cookieConsentMarketingDescription')),
            React.createElement("div", { className: "cookie-consent__button-container" },
                React.createElement(Button, { onClick: () => {
                        acceptAll();
                        setHideCookieConsent(!hideCookieConsent);
                    }, className: "cookie-consent__accept-all-button" }, t('cookieConsentAcceptAllButton')),
                React.createElement(Button, { onClick: () => {
                        setShowCustomizeCookies(true);
                        setShowCookieConsent(false);
                    }, className: "cookie-consent__customize-button" }, t('cookieConsentCustomizeButton'))),
            React.createElement("div", { className: "cookie-consent__description" },
                t('cookieConsentReadMoreDescription'),
                React.createElement(Link, { to: "/article/privacy", className: "cookie-consent__description--link" }, t('cookieConsentPolicyLink')),
                ".")));
    }
    else if (showCustomizeCookies) {
        return (React.createElement("div", { className: "cookie-consent__container" },
            React.createElement("div", { className: "cookie-consent__scroll-on-mobile" },
                React.createElement("div", { className: "cookie-consent__cookie-information" },
                    React.createElement("b", null, t('cookieInformationMarketingTitle')),
                    React.createElement("div", { className: "cookie-consent__cookie-information--description" }, t('cookieInformationMarketingDescription')),
                    React.createElement("div", { className: "cookie-consent__consent-switch" },
                        React.createElement(Switch, { on: adConsent, onChange: () => setAdConsent(!adConsent) }),
                        React.createElement("div", { className: "cookie-consent__consent-switch--text" }, t('cookieInformationMarketingAcceptText')))),
                React.createElement("div", { className: "cookie-consent__cookie-information" },
                    React.createElement("b", null, t('cookieInformationAnalyticsTitle')),
                    React.createElement("div", { className: "cookie-consent__cookie-information--description" }, t('cookieInformationAnalyticsDescription')),
                    React.createElement("div", { className: "cookie-consent__consent-switch" },
                        React.createElement(Switch, { on: analyticsConsent, onChange: () => setAnalyticsConsent(!analyticsConsent) }),
                        React.createElement("div", { className: "cookie-consent__consent-switch--text" }, t('cookieInformationAnalyticsAcceptText')))),
                React.createElement("div", { className: "cookie-consent__cookie-information" },
                    React.createElement("b", null, t('cookieInformationNecessaryTitle')),
                    React.createElement("div", { className: "cookie-consent__cookie-information--description" }, t('cookieInformationNecessaryDescription')),
                    React.createElement("div", { className: "cookie-consent__consent-switch" },
                        React.createElement(Switch, { on: true, onChange: () => { } }),
                        React.createElement("div", { className: "cookie-consent__consent-switch--text" }, t('cookieInformationNecessaryAcceptText'))))),
            React.createElement("div", { className: "cookie-consent__button-container" },
                React.createElement(Button, { onClick: () => {
                        acceptAll();
                        setHideCookieConsent(!hideCookieConsent);
                    }, className: "cookie-consent__accept-all-button" }, t('cookieConsentAcceptAllButton')),
                React.createElement(Button, { onClick: () => {
                        acceptSome(adConsent, analyticsConsent);
                        setHideCookieConsent(!hideCookieConsent);
                    }, className: "cookie-consent__customize-button" }, t('cookieConsentSaveButton')))));
    }
}
export default CookieConsent;
